import { CircularProgress } from '@mui/material'
import { ReactComponent as DeleteIcon } from 'assets/icons/trash.svg'
import { orderFormSpace } from 'feature/productOrder/namespaces/orderFormSpace'
import { useSetNotice } from 'hooks/useSetNotice'
import { useState } from 'react'
import { IconButton } from 'ui'
import { Severity } from 'widget/Notifications'

import style from './DragDropFileItem.module.scss'

type TDragDropFileItem = {
  item: orderFormSpace.Images
  index: number
  removeThumbnail?: (index: number) => void | Promise<void>
}
// добавленный файл в dragDropInput
export function DragDropFileItem({
  item,
  index,
  removeThumbnail,
}: TDragDropFileItem) {
  const setNotice = useSetNotice()
  const [isRemoving, setIsRemoving] = useState(false)

  const onErrorHandler = () => {
    if (removeThumbnail) removeThumbnail(index)
    setNotice('Ошибка загрузки файлов', Severity.error)
  }

  const handleRemove = async () => {
    if (!removeThumbnail) return

    setIsRemoving(true)
    try {
      await removeThumbnail(index)
    } finally {
      setIsRemoving(false)
    }
  }

  const getFileExtensionLabel = () => {
    const hasExtension = item.name?.includes('.')
    const extension = hasExtension ? item.name?.split('.').pop() : null
    return extension ? extension.toUpperCase() : 'FILE'
  }

  return (
    <div className={style.file}>
      <div className={style.fileInf}>
        {item.previewUrl ? (
          <img
            src={item.previewUrl}
            alt={item.name}
            onError={onErrorHandler}
            width={'56px'}
            height={'56px'}
          />
        ) : (
          <div className={style.progress}>
            {item.serverUid ? (
              <div className={style.placeholder}>{getFileExtensionLabel()}</div>
            ) : (
              <CircularProgress
                size={'30px'}
                className={style.progressLoader}
              />
            )}
          </div>
        )}
        <div className={style.fileTextInf}>
          <span className={style.fileName}>{item.name}</span>
          <span className='caption'>{item.size}</span>
        </div>
      </div>
      {removeThumbnail && (item.serverUid || item.previewUrl) && (
        <IconButton
          color='secondary'
          onClick={handleRemove}
          disabled={isRemoving}
          data-testid='drag-drop-remove-file'
        >
          {isRemoving ? <CircularProgress size={20} /> : <DeleteIcon />}
        </IconButton>
      )}
    </div>
  )
}
